/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_TitleInputs */

const en_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Throw Out the Snapshot`)
};

const es_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tira la foto fija`)
};

const de_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weg mit der Momentaufnahme`)
};

const zh_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扔掉定格画面`)
};

const ar_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخلَّ عن اللقطة الثابتة`)
};

const fr_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetez l'instantané`)
};

const vi_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ tấm ảnh tĩnh`)
};

const sw_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achana na Picha Tuli`)
};

const th_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทิ้งภาพนิ่งไปได้เลย`)
};

const bs_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baci statičnu fotografiju`)
};

const ja_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スナップショットを捨てる`)
};

const ko_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스냅샷 버리기`)
};

const pt_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueça o instantâneo`)
};

const it_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimentica il fermo immagine`)
};

const sv_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släpp stillbilden`)
};

const nl_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi de momentopname weg`)
};

const da_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smid øjebliksbilledet væk`)
};

const nb_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slipp stillbildet`)
};

const fi_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unohda pysäytyskuva`)
};

const pl_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapomnij o stopklatce`)
};

const ru_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забудьте о стоп-кадре`)
};

const tr_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlık fotoğrafı unutun`)
};

const hi_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टिल फ्रेम छोड़ दें`)
};

const id_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buang Gambar Diam`)
};

const ms_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupakan Gambar Pegun`)
};

const cs_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapomeňte na momentku`)
};

const el_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αφήστε τη στιγμιαία εικόνα`)
};

const he_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שכחו מתמונת הרגע`)
};

const af_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi die oomblikskoot weg`)
};

const hu_method_content_step_03_title = /** @type {(inputs: Method_Content_Step_03_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobd el a pillanatképet`)
};

/**
* | output |
* | --- |
* | "Throw Out the Snapshot" |
*
* @param {Method_Content_Step_03_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_title = /** @type {((inputs?: Method_Content_Step_03_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_title(inputs)
	if (locale === "de") return de_method_content_step_03_title(inputs)
	if (locale === "zh") return zh_method_content_step_03_title(inputs)
	if (locale === "ar") return ar_method_content_step_03_title(inputs)
	if (locale === "fr") return fr_method_content_step_03_title(inputs)
	if (locale === "vi") return vi_method_content_step_03_title(inputs)
	if (locale === "sw") return sw_method_content_step_03_title(inputs)
	if (locale === "th") return th_method_content_step_03_title(inputs)
	if (locale === "bs") return bs_method_content_step_03_title(inputs)
	if (locale === "ja") return ja_method_content_step_03_title(inputs)
	if (locale === "ko") return ko_method_content_step_03_title(inputs)
	if (locale === "pt") return pt_method_content_step_03_title(inputs)
	if (locale === "it") return it_method_content_step_03_title(inputs)
	if (locale === "sv") return sv_method_content_step_03_title(inputs)
	if (locale === "nl") return nl_method_content_step_03_title(inputs)
	if (locale === "da") return da_method_content_step_03_title(inputs)
	if (locale === "nb") return nb_method_content_step_03_title(inputs)
	if (locale === "fi") return fi_method_content_step_03_title(inputs)
	if (locale === "pl") return pl_method_content_step_03_title(inputs)
	if (locale === "ru") return ru_method_content_step_03_title(inputs)
	if (locale === "tr") return tr_method_content_step_03_title(inputs)
	if (locale === "hi") return hi_method_content_step_03_title(inputs)
	if (locale === "id") return id_method_content_step_03_title(inputs)
	if (locale === "ms") return ms_method_content_step_03_title(inputs)
	if (locale === "cs") return cs_method_content_step_03_title(inputs)
	if (locale === "el") return el_method_content_step_03_title(inputs)
	if (locale === "he") return he_method_content_step_03_title(inputs)
	if (locale === "af") return af_method_content_step_03_title(inputs)
	if (locale === "hu") return hu_method_content_step_03_title(inputs)
	return en_method_content_step_03_title(inputs)
});